module.exports = __webpack_public_path__ + "static/qui-est-nader-abou-anas-fcdb7a99f2949627d5e5fcf73710aa72.jpeg";